import React from "react"
import PropTypes from "prop-types"
import { FlashMessge } from "components"
import COLOR_PALETTE from "constants/color-palette"
import { MyMazdaPolicyDetail } from "blocks"
import { withRadium, DetectCompact } from "higher-order-components"
import { A, Section, H3, H5, Content, Space } from "AtomicComponents"

const policyTypesWithExpiredMessage = ["RoadSide", "Allianz", "Assist", "Insurance", "CMP", "LPI", "VPI"]

const MyMazdaPolicySummary = props => (
  <div>
    {
      policyTypesWithExpiredMessage.includes(props.policyType) &&
      props.isExpired &&
      <FlashMessge
        style={{ backgroundColor: "white" }}
        type="ERROR"
        message={
          <span>
            This policy is expired. {
              props.policyType === "Allianz" || props.policyType === "Assist" ?
              <span>Please contact us on 1800 034 411.</span>
              :
              <span><A styleName="black" external href={props.upgradeOptionsUrl || "/mymazda"}><strong>View upgrade options</strong></A> or contact your dealer.</span>
            }
          </span>
        }
      />
    }
    <Section padding backgroundColor={COLOR_PALETTE.GRAY_LIGHTER}>
      <div style={{ paddingBottom: "2em", textAlign: "center" }}>
        <img
          src={props.imageSrc}
          alt={props.heading}
          style={{ maxWidth: "10em", display: "block", margin: "0 auto 1em" }} />
        <H3 withDetails>{props.heading}</H3>
      </div>
      <div style={styles.wrapper(props.compact)}>
        <div style={styles.wrapperLeft(props.compact)}>
          {props.warrantyInteractive && <H5>{props.warrantyInteractive}</H5>}
          {props.warrantyInteractive && <Space />}
          {props.warrantyblurb && (
            <Content textAlign="left" xmlString={"<p>" + props.warrantyblurb + "</p>"} />
          )}
          <Content textAlign="left" xmlString={props.blurb} />
        </div>
        <div style={styles.wrapperRight(props.compact)}>
          <MyMazdaPolicyDetail {...props} />
        </div>
      </div>
    </Section>
  </div>
)

const styles = {
  wrapper: compact => ({
    width: "100%",
    borderTop: "1px solid " + COLOR_PALETTE.GRAY,
    display: "flex",
    justifyContent: "space-between",
    paddingTop: "4em",
    flexDirection: compact ? "column" : "row"
  }),
  wrapperLeft: compact => ({
    order: compact ? "2" : "1",
    flex: `1 1 ${compact ? "100" : "70"}%`,
    paddingRight: compact ? "0" : "2em"
  }),
  wrapperRight: compact => ({
    order: compact ? "1" : "2",
    flex: `1 1 ${compact ? "100" : "30"}%`,
    marginBottom: compact ? "2em" : "0"
  })
}

MyMazdaPolicySummary.propTypes = {
  policyType: PropTypes.oneOf(policyTypesWithExpiredMessage),
  upgradeOptionsUrl: PropTypes.string,
  isExpired: PropTypes.bool,
  compact: PropTypes.bool,
  warrantyInteractive: PropTypes.string,
  warrantyblurb: PropTypes.string,
  imageSrc: PropTypes.string,
  heading: PropTypes.string,
  blurb: PropTypes.string
}

export default withRadium(DetectCompact())(MyMazdaPolicySummary)



// WEBPACK FOOTER //
// ./src/blocks/mymazda/policies/summary.jsx